import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

// The "Reset your password" email link can land on any page: Supabase only
// honours the /admin/reset-password redirect if it's on the project's allow
// list, otherwise it sends people to the site root. Whatever page it lands on,
// forward to /admin/reset-password.
//
// Read the URL at module load: supabase-js strips the tokens from the hash as
// soon as it has processed them, which can happen before any effect runs.
const RESET_PATH = "/admin/reset-password";
const landingParams = (() => {
  if (typeof window === "undefined") return null;
  const hash = new URLSearchParams(window.location.hash.replace(/^#/, ""));
  const query = new URLSearchParams(window.location.search);
  const get = (key: string) => hash.get(key) ?? query.get(key);
  return {
    isRecovery: get("type") === "recovery",
    error: get("error_code") ? get("error_description") || "This reset link is invalid or has expired." : null,
  };
})();

export default function PasswordRecoveryRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    if (window.location.pathname !== RESET_PATH) {
      if (landingParams?.error) {
        navigate(RESET_PATH, { replace: true, state: { linkError: landingParams.error } });
      } else if (landingParams?.isRecovery) {
        navigate(RESET_PATH, { replace: true });
      }
    }
    const { data } = supabase.auth.onAuthStateChange((event) => {
      if (event === "PASSWORD_RECOVERY" && window.location.pathname !== RESET_PATH) {
        navigate(RESET_PATH, { replace: true });
      }
    });
    return () => data.subscription.unsubscribe();
  }, [navigate]);

  return null;
}
